import enhanced from './enhanced-content';
import EnhancedContentDesktop from '../../../../components/enhanced-content/enhanced-content';

export default enhanced(EnhancedContentDesktop);
